/**
 * Home / Portal Demo — agent fixtures.
 *
 * THROWAWAY DEMO CODE. The /inbox demo splits across surfaces:
 *   • Tasks tab  — ONE human-in-the-loop task (an agent asking a question) + its
 *     comment thread, in the resettable `./tasks-store`.
 *   • Inbox tab  — notifications with actions (a failed workflow, an agent
 *     eligible to materialize, an approval, a memory review). Those live in
 *     `./inbox-store` so they reset to unread.
 *
 * This module owns the synthetic agent the materialize notification deep-links
 * to. Delete with src/demo/home.
 */

import type { AgentDefinitionResponse } from '@erp/rpc';

export const HOME_DEMO_KEY = 'home';

const ORG_ID = 'c1000000-0000-4000-8000-000000000000';

/** The (synthetic) agent the "materialize" notification deep-links to. */
export const HOME_DEMO_AGENT_ID = 'c1000000-0000-4000-8000-0000000000a1';

/** A deep-link surfaced on a task, resolved by `TaskDemoLink`. */
export interface TaskDemoLinkMeta {
  kind: 'workflow' | 'materialize';
  id: string;
  label: string;
}

function minutesAgo(min: number): Date {
  return new Date(Date.now() - min * 60_000);
}

/**
 * The agent the materialize notification points at. The materialize page only
 * needs the definition to load (it reads `name`); the layout errors otherwise.
 */
export const HOME_DEMO_AGENT: AgentDefinitionResponse = {
  id: HOME_DEMO_AGENT_ID,
  organizationId: ORG_ID,
  createdBy: ORG_ID,
  name: 'Reconciliation agent',
  description: 'Matches remittances to open invoices and clears payments.',
  templateType: null,
  systemPrompt:
    'You reconcile customer payments against open invoices and clear them.',
  modelConfig: {},
  config: {},
  inputFields: [],
  outputFields: [],
  tools: [],
  isActive: true,
  version: 4,
  createdAt: new Date(Date.now() - 90 * 86_400_000).toISOString(),
  updatedAt: minutesAgo(42).toISOString(),
};
